import React, { lazy } from 'react';

import { Spin } from 'antd';

import { RouteObject } from 'react-router-dom';

const FinalConfirmation = lazy(
  () => import('@pages/landing/FinalConfirmation'),
);

export const FinalConfirmationRoutes: RouteObject[] = [
  {
    path: '/final-confirmation',
    element: (
      <React.Suspense
        fallback={
          <div className="text-center">
            <Spin />
          </div>
        }
      >
        <FinalConfirmation />
      </React.Suspense>
    ),
  },
];
